/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const SectionBackground = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 1326.5"
      enableBackground="new 0 0 1440 1326.5"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="Layer_1"
      xmlSpace="preserve"
      x="0px"
      y="0px"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <path
        style={{
          fill: '#EDEDED',
        }}
        d="M728.9,134.7c-367.4-21.1-615,18.1-728.9,43v1148.9h152.7c460.6-250.1,979.1-260.2,1482.7-209.8
	c419,41.9,747.7-100.9,864.6-161.1V0h-444.6C1698.8,71.6,1210.8,162.3,728.9,134.7z"
      />
    </svg>
  );
};

export default SectionBackground;

SectionBackground.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};
